// Mock data for Deegford — luxury perfume & attar store (frontend-only)
// NOTE: This data is MOCKED. Cart/wishlist persist in browser localStorage.

export const announcements = [
  "Free Shipping on all orders above ₹999 ✨",
  "Shop now & get a chance to win a Royal Gift Hamper 🎁",
  "Buy 3 Attars at just ₹1799 — Limited Period Offer",
];

export const navLinks = [
  {
    label: "PERFUMES",
    to: "/collections/perfumes",
    children: [
      { label: "For Him", to: "/collections/perfumes?gender=men" },
      { label: "For Her", to: "/collections/perfumes?gender=women" },
      { label: "Unisex", to: "/collections/perfumes?gender=unisex" },
    ],
  },
  { label: "ATTARS", to: "/collections/attars" },
  { label: "GIFT SETS", to: "/collections/gift-sets" },
  { label: "BAKHOOR", to: "/collections/bakhoor" },
  { label: "BESTSELLERS", to: "/collections/bestsellers" },
  { label: "NEW ARRIVALS", to: "/collections/new-arrivals" },
];

export const heroSlides = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1594035910387-fea47794261f",
    eyebrow: "THE SIGNATURE COLLECTION",
    title: "Worn by Royalty",
    subtitle: "Discover Deegford's most opulent oud creations",
    cta: "Shop Premium",
    to: "/collections/perfumes",
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1754578645612-850d520385a8",
    eyebrow: "FARM TO FRAGRANCE",
    title: "The Art of Attar",
    subtitle: "Pure, alcohol-free concentrated perfumes",
    cta: "Explore Attars",
    to: "/collections/attars",
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1664181019109-2eb363604256",
    eyebrow: "GIFTING REIMAGINED",
    title: "Buy 3 at ₹1799",
    subtitle: "Curated luxury gift sets for every occasion",
    cta: "Shop Gift Sets",
    to: "/collections/gift-sets",
  },
];

export const categories = [
  {
    label: "Perfumes",
    to: "/collections/perfumes",
    image: "https://images.unsplash.com/photo-1622618991746-fe6004db3a47",
  },
  {
    label: "Attars",
    to: "/collections/attars",
    image: "https://images.unsplash.com/photo-1669444699729-f55f7cf9f82b",
  },
  {
    label: "Gift Sets",
    to: "/collections/gift-sets",
    image: "https://images.unsplash.com/photo-1590156351885-f73330202730",
  },
  {
    label: "Bakhoor",
    to: "/collections/bakhoor",
    image: "https://images.unsplash.com/photo-1599285062038-950c5e0b672a",
  },
];

const P = (
  id, name, gender, category, scent, price, mrp, rating, reviews, image, badges = [], sizes = []
) => ({
  id,
  slug: name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, ""),
  name,
  gender,
  category,
  scent,
  price,
  mrp,
  discount: Math.round(((mrp - price) / mrp) * 100),
  rating,
  reviews,
  image,
  badges,
  sizes: sizes.length ? sizes : ["50ml", "100ml"],
  description:
    "An exquisite Deegford composition crafted with the finest ingredients. A long-lasting, sophisticated fragrance that opens with bright top notes, settling into a warm, sensual base of oud, amber and musk — a true signature of luxury.",
  notes: { top: ["Bergamot", "Saffron"], heart: ["Rose", "Jasmine"], base: ["Oud", "Amber", "Musk"] },
});

export const products = [
  P(1, "Noir Oud", "men", "perfumes", "Amber Woody", 2400, 3000, 4.7, 88, "https://images.unsplash.com/photo-1593487568720-92097fb460fb", ["Bestseller"]),
  P(2, "Royal Amber", "unisex", "perfumes", "Amber", 1599, 2000, 4.8, 64, "https://images.unsplash.com/photo-1622618991746-fe6004db3a47", ["Bestseller"]),
  P(3, "Velvet Rose", "women", "perfumes", "Floral", 3200, 4000, 4.6, 72, "https://images.pexels.com/photos/7703038/pexels-photo-7703038.jpeg", []),
  P(4, "Imperial Musk", "unisex", "perfumes", "Musky", 1200, 2000, 4.7, 55, "https://images.pexels.com/photos/36389336/pexels-photo-36389336.jpeg", ["40% Off"]),
  P(5, "Golden Dunes", "men", "perfumes", "Citrus", 4000, 5000, 4.65, 99, "https://images.unsplash.com/photo-1543422655-ac1c6ca993ed", ["Premium"]),
  P(6, "Sapphire Aqua", "men", "perfumes", "Aquatic", 2250, 2500, 4.5, 41, "https://images.unsplash.com/photo-1591375372226-3531cf2eb6d3", ["New"]),
  P(7, "Crimson Saffron", "unisex", "perfumes", "Spicy", 3500, 5000, 4.59, 59, "https://images.unsplash.com/photo-1678984633768-c4fd5a01732a", []),
  P(8, "White Pearl", "women", "perfumes", "Floral Musky", 1599, 2000, 4.83, 18, "https://images.unsplash.com/photo-1590736704728-f4730bb30770", ["Bestseller"]),
  P(9, "Black Diamond", "men", "perfumes", "Leather", 4500, 6000, 4.6, 33, "https://images.unsplash.com/photo-1589820933944-1ec1ae95b089", ["Premium"]),
  P(10, "Aurum Gold", "women", "perfumes", "Fruity", 3200, 4000, 4.64, 72, "https://images.unsplash.com/photo-1514348871858-1d3c20902571", []),
  P(11, "Silver Mirage", "men", "perfumes", "Citrus", 1200, 2000, 4.71, 55, "https://images.unsplash.com/photo-1598634222670-87c5f558119c", ["40% Off"]),
  P(12, "Desert Rose", "women", "perfumes", "Floral", 2400, 3000, 4.55, 47, "https://images.unsplash.com/photo-1553699357-fdefb876c402", ["New"]),
  // Attars
  P(13, "Oudh Mukhallat", "unisex", "attars", "Oudhy", 1999, 2500, 4.7, 41, "https://images.unsplash.com/photo-1669444699729-f55f7cf9f82b", ["Bestseller"], ["6ml", "12ml"]),
  P(14, "1001 Nights", "unisex", "attars", "Oudhy", 6600, 7500, 4.8, 22, "https://images.unsplash.com/photo-1636503461005-4f7dd6081d27", ["Premium"], ["12ml", "30ml"]),
  P(15, "Royal Misk", "unisex", "attars", "Musky", 1600, 2000, 4.6, 38, "https://images.unsplash.com/photo-1621814374283-57cc5d0d39c2", [], ["6ml", "14ml"]),
  // Gift sets
  P(16, "Gold Series Giftpack", "unisex", "gift-sets", "Assorted", 899, 1299, 4.51, 41, "https://images.unsplash.com/photo-1590156351885-f73330202730", ["31% Off"], ["4 x 5ml"]),
  P(17, "Royal Series Giftpack", "unisex", "gift-sets", "Assorted", 1999, 2500, 4.49, 41, "https://images.unsplash.com/photo-1734779756318-9ff28c6ebfb7", ["Bestseller"], ["4 x 20ml"]),
  // Bakhoor
  P(18, "Bakhoor Royal Oud", "unisex", "bakhoor", "Oriental", 1200, 1500, 4.4, 15, "https://images.unsplash.com/photo-1599285062038-950c5e0b672a", ["New"], ["40 gms"]),
  P(19, "Bakhoor Amber Mist", "unisex", "bakhoor", "Oriental Woody", 1050, 1500, 4.3, 12, "https://images.unsplash.com/photo-1612704057720-e8f66bade6ca", ["30% Off"], ["20 gms"]),
];

export const celebrities = [
  { name: "Royal Edition", fav: products[4], image: "https://images.unsplash.com/photo-1594035910387-fea47794261f" },
];

export const testimonials = [
  {
    quote: "I like things that feel effortless yet premium, and Deegford fits right in — smooth, balanced, and something you can wear anytime.",
    name: "Aarav Mehta",
    role: "Actor • Brand Ambassador",
    image: "https://images.unsplash.com/photo-1775036423115-b0f46d5b5694",
  },
  {
    quote: "It's understated yet distinctive, something that complements your presence without overpowering it. That's what makes it stand out.",
    name: "Zara Khan",
    role: "Designer • Fragrance Enthusiast",
    image: "https://images.unsplash.com/photo-1762843354674-adabdd6c4072",
  },
  {
    quote: "Been using this regularly and honestly, it just feels right — easy, smooth, and something people actually notice.",
    name: "Kabir Rao",
    role: "Entrepreneur • Entertainer",
    image: "https://images.unsplash.com/photo-1614252368727-99517bc90d7b",
  },
];

export const features = [
  { title: "75 Years Legacy", desc: "Decades of perfumery mastery" },
  { title: "Farm to Fragrance", desc: "Sourced from the finest origins" },
  { title: "Loved Worldwide", desc: "Trusted by millions globally" },
];

export const blogs = [
  {
    title: "How To Choose The Perfect Perfume For Yourself Online",
    image: "https://images.unsplash.com/photo-1589820933944-1ec1ae95b089",
    link: "Find Your Fragrance",
  },
  {
    title: "How to Wear Attar Like Royalty: The Complete Guide",
    image: "https://images.unsplash.com/photo-1669444699729-f55f7cf9f82b",
    link: "Find Your Fragrance",
  },
  {
    title: "Perfume vs Attar: Benefits, Uses, And Best Picks",
    image: "https://images.unsplash.com/photo-1543422655-ac1c6ca993ed",
    link: "Find Your Fragrance",
  },
  {
    title: "Top 5 Daily Wear Scents For Men By Deegford",
    image: "https://images.unsplash.com/photo-1593487568720-92097fb460fb",
    link: "Find Your Fragrance",
  },
];

export const footer = {
  about:
    "Deegford is a house of fine fragrances — crafting luxurious perfumes, attars and bakhoor inspired by timeless Arabian artistry.",
  columns: [
    {
      title: "Shop",
      links: ["Perfumes", "Attars", "Gift Sets", "Bakhoor", "Bestsellers", "New Arrivals"],
    },
    {
      title: "About",
      links: ["Our Story", "Legacy", "Stores", "Careers", "Blog"],
    },
    {
      title: "Help",
      links: ["Track Order", "Shipping Policy", "Returns & Refunds", "FAQs", "Contact Us"],
    },
  ],
};

export const collectionMeta = {
  perfumes: { title: "Perfumes", subtitle: "Eau de Parfum for Him, Her & Unisex" },
  attars: { title: "Attars", subtitle: "Pure, alcohol-free concentrated perfumes" },
  "gift-sets": { title: "Gift Sets", subtitle: "Curated luxury gifting" },
  bakhoor: { title: "Bakhoor", subtitle: "Traditional oriental incense" },
  bestsellers: { title: "Bestsellers", subtitle: "Our most loved fragrances" },
  "new-arrivals": { title: "New Arrivals", subtitle: "The latest from Deegford" },
  all: { title: "All Products", subtitle: "The complete Deegford collection" },
};
